'use client';

import { useQuery } from '@tanstack/react-query';
import { storyKeys } from '../queryKeys';
import { getStory } from '../actions/getStory';
import type { Story } from '../types/story';

export function useStory(storyId: string | null | undefined) {
  return useQuery<Story | null>({
    queryKey: storyKeys.detail(storyId ?? ''),
    queryFn: () => getStory(storyId!),
    enabled: !!storyId,
  });
}
